function ProductSkeleton() {
  return (
    <div className="caf-product-card caf-product-skeleton" aria-hidden="true">
      <div className="caf-product-card__media">
        <div className="caf-product-skeleton__media caf-product-card__placeholder" />
      </div>
      <div className="caf-product-card__body">
        <div className="caf-product-skeleton__line caf-product-skeleton__line--sm" />
        <div className="caf-product-skeleton__line caf-product-skeleton__line--lg" />
        <div className="caf-product-card__price-row">
          <div className="caf-product-skeleton__line caf-product-skeleton__line--price" />
          <div className="caf-product-skeleton__line caf-product-skeleton__line--pack" />
        </div>
      </div>
      <div className="caf-product-card__footer">
        <div className="caf-product-skeleton__line caf-product-skeleton__line--btn" />
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 6 }) {
  return (
    <div className="caf-product-grid">
      {Array.from({ length: count }, (_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
}

export default ProductSkeleton;
